"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eyeOff = void 0;
var eyeOff = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"
    },
    "children": []
  }, {
    "name": "line",
    "attribs": {
      "x1": "1",
      "y1": "1",
      "x2": "23",
      "y2": "23"
    },
    "children": []
  }],
  "attribs": {
    "fill": "none",
    "stroke": "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }
};
exports.eyeOff = eyeOff;


//////////////////
// WEBPACK FOOTER
// ./~/react-icons-kit/feather/eyeOff.js
// module id = 2111
// module chunks = 0